import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import styles from './Sidebar.module.css';

export default function NavItem({
  path,
  label,
  Logo,
}) {
  const { t } = useTranslation();
  const route = useLocation();
  const selected = route?.pathname && route?.pathname?.length && route?.pathname.split('/') && route?.pathname.split('/').length
   && route?.pathname.split('/').length > 2
    ? route.pathname.split('/')[2] === label : false;
  return (
    <li>
      <Link to={path} className={`${styles.navLink} ${selected ? styles.navLinkSelected : ''}`}>
        <div
          className={`${styles.navLogos} ${selected ? styles.navLinkSelectedLogo : ''}`}
        >
          <Logo size={14} />
        </div>
        <div style={{ marginLeft: '5px' }}>
          {t(`nav.${label}`, { defaultValue: label })}
        </div>
      </Link>
    </li>
  );
}

NavItem.propTypes = {
  path: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  Logo: PropTypes.object.isRequired,
};
